import { CreateSurgicalSchedule } from 'domain/usecases/create-surgical-schedule/create-surgical-schedule'
import { SurgicalScheduleRepository } from 'repository/interfaces/surgical-schedule-repository'

export class RemoteCreateSurgicalSchedule implements CreateSurgicalSchedule {
  constructor(
    private readonly surgicalScheduleRepository: SurgicalScheduleRepository
  ) {}

  add(
    params: CreateSurgicalSchedule.Params
  ): Promise<CreateSurgicalSchedule.Model> {
    return this.surgicalScheduleRepository.createSurgicalSchedule(params)
  }
}
